import {
  CLEAR_EDITS
  SET_COLUMNS
  SET_COLUMN_WIDTHS
  SET_CONTEXT_MENU_EVENT
  SET_COUNT
  SET_CURRENT_HIGHEST_REQUESTED
  SET_EDITS
  SET_FILTERS
  SET_IS_DRAGGING
  SET_IS_ESCAPING_EDIT_MODE
  SET_IS_FETCHING
  SET_IS_IN_EDIT_MODE
  SET_LOADING
  SET_NODE_ORDER
  SET_REDOS
  SET_RELATIONS_MAP
  SET_RESIZED_COLUMN_WIDTHS
  SET_ROWS_TO_BE_DELETED
  SET_SELECTION
  SET_SELECTION_TYPE
  SET_SORTER
  SET_UNDOS
} from './actionTypes'

export reducer = (state, { type, payload }) ->
  try
    switch (type)
      when CLEAR_EDITS
        { state..., edits: {}, editHistory: [state.editHistory..., state.edits], undoHistory: [], rowsToBeDeleted: {} }
      when SET_COLUMNS
        { state..., columns: payload.data }
      when SET_COLUMN_WIDTHS
        { state..., columnWidths: { payload.data..., state.resizedColumnWidths... } }
      when SET_CONTEXT_MENU_EVENT
        { state..., ctxMenuEvt: payload.data }
      when SET_COUNT
        { state..., count: payload.data }
      when SET_CURRENT_HIGHEST_REQUESTED
        { state..., currentHighestRequested: payload.data }
      when SET_EDITS
        { prevEdits, nextEdits } = payload.data
        { state..., edits: { state.edits..., nextEdits... }, editHistory: [state.editHistory..., prevEdits], undoHistory: [] }
      when SET_FILTERS
        { state..., filters: payload.data }
      when SET_IS_DRAGGING
        { state..., isDragging: payload.data }
      when SET_IS_ESCAPING_EDIT_MODE
        { state..., isEscapingEditMode: payload.data }
      when SET_IS_FETCHING
        { state..., isFetching: payload.data }
      when SET_IS_IN_EDIT_MODE
        { state..., isInEditMode: payload.data }
      when SET_LOADING
        { state..., loading: payload.data }
      when SET_NODE_ORDER
        { state..., nodeOrder: payload.data }
      when SET_REDOS
        nextEdits = state.undoHistory.pop()
        { state..., edits: nextEdits, editHistory: [state.editHistory..., payload.data], undoHistory: [state.undoHistory...] }
      when SET_RELATIONS_MAP
        { state..., relationsMap: payload.data }
      when SET_RESIZED_COLUMN_WIDTHS
        {
          state...,
          columnWidths: { state.columnWidths..., payload.data... }
          resizedColumnWidths: { state.resizedColumnWidths..., payload.data... }
        }
      when SET_ROWS_TO_BE_DELETED
        { state..., rowsToBeDeleted: payload.data }
      when SET_SELECTION
        { state..., selection: payload.data }
      when SET_SELECTION_TYPE
        { state..., selectionType: payload.data }
      when SET_SORTER
        newSorter = {
          key: payload.data
          ascending: if (state.sorter.key is payload.data) then !state.sorter.ascending else true
        }
        { state..., sorter: newSorter }
      when SET_UNDOS
        nextEdits = state.editHistory.pop()
        { state..., edits: nextEdits, editHistory: [state.editHistory...], undoHistory: [state.undoHistory..., payload.data] }
      else
        throw new Error("SpreadSheetData reducer recieved an invalid action type (#{ type }).")

  catch e
    console.error(e)
